export default __webpack_public_path__ + "static/media/profile_pic.30e11a75.png";